<selfai-platform-model
  [models]="models$ | async"
  (backEvent)="onBack()"
  (submitEvent)="onSubmit($event)"
></selfai-platform-model>
